import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_MEAL_DEAL = apiPromiseTypes('offers-experience', 'get');
